import { ChipAwareMarkdown } from '@/markdown/chips';

/**
 * All decoration sections render as one continuous disclaimer voice
 * (uniform 75% opacity). Spacing is owned by the `.cal-decoration`
 * rules in styles/index.css:
 *  - one blank-line "br" of space before the first note in a run
 *  - consecutive notes collapse the parent flex gap → flush lines
 *  - inner <p> margins zeroed so each note is tight
 *
 * Body is rendered through ChipAwareMarkdown so backend markdown
 * (e.g. **bold** labels, links) is parsed properly. (An earlier
 * version split the raw string by ":"/"," to build a numbered list,
 * which leaked literal `**` markers — removed.)
 */
export function DecorationNote({ body }: { body: string }): JSX.Element {
  return (
    <div className="cal-decoration tw-text-[11px] tw-italic tw-leading-relaxed tw-opacity-[0.75]">
      <ChipAwareMarkdown source={body} />
    </div>
  );
}
